import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { confirmObject } from '../../models/confirms.model';

@Injectable({providedIn: 'root'})
export class StatusUpdateDataTransferService {
  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();

  sendData(data: confirmObject[]) {
    this.dataSubject.next(data);
  }
}
